import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import styles from './styles.module.scss'

type HipaaAddOnModalActionsProps = {
  isActive: boolean
  onCancel: () => void
  onPrimary: () => void
}

export const HipaaAddOnModalActions = observer(
  ({ isActive, onCancel, onPrimary }: HipaaAddOnModalActionsProps) => {
    return (
      <div className={styles.actions}>
        <Button
          text='Cancel'
          typeBtn='contained'
          contained='secondary'
          size='medium'
          onClick={onCancel}
        />
        <Button
          text={isActive ? 'Go to security' : 'Chat with support'}
          typeBtn='contained'
          size='medium'
          onClick={onPrimary}
        />
      </div>
    )
  }
)
